import React from "react";
import s from "./betaLabel.scss";
import cx from "classnames";

const BetaLabel = ({ isLarge = false, fullyRounded = false }) => (
  <div className={cx(s.label, { [s.large]: isLarge, "rounded-full uppercase text-[10px]": fullyRounded })}>
    {isLarge ? "NEW" : "New"}
  </div>
);

export default BetaLabel;
